import { useQuery } from 'react-query';
import { getInvoices } from '../api/getInvoices';
import { Invoice } from '../api/getInvoices.types';

export const useGetInvoices = () => useQuery<Invoice[] | Error>(['invoices'], () => getInvoices());
